import { API_ROUTES } from '@/common/constants'
import { useMutation, useQuery } from '@tanstack/react-query'
import {
    getAccountDetails,
    getBalance,
    getPayId,
    getTransactions,
    saveAccountDetails,
    saveWithdrawalRequest,
} from './walletApi'
import { toast } from 'sonner'
import { AccountDetails, WithdrawRequest } from './types'
import { defaultOptions } from '@/common/utils/queryOptions'

export const useFetchBalance = (accountId: string | null, options = defaultOptions) => {
    const { enabled, refetchInterval } = options
    return useQuery({
        queryKey: [API_ROUTES.balance, accountId],
        queryFn: getBalance,
        enabled,
        refetchOnMount: true,
        refetchInterval,
    })
}

export const useFetchTransactions = (accountId: string | null, options = defaultOptions) => {
    const { enabled, refetchInterval } = options
    return useQuery({
        queryKey: [API_ROUTES.transactions, accountId],
        queryFn: getTransactions,
        enabled,
        refetchOnMount: true,
        refetchInterval,
    })
}

export const useFetchPayId = (accountId: string | null, enabled = true) => {
    return useQuery({
        queryKey: [API_ROUTES.payId, accountId],
        queryFn: getPayId,
        enabled,
    })
}

export const useFetchAccountDetails = (accountId: string | null, isEnabled = true) => {
    return useQuery({
        queryKey: [API_ROUTES.accountDetails, accountId],
        queryFn: getAccountDetails,
        enabled: isEnabled,
        refetchOnMount: true,
    })
}

export const useSaveAccountDetails = () => {
    return useMutation({
        mutationFn: (accountDetails: AccountDetails) => saveAccountDetails(accountDetails),
        onSuccess: () => {},
        onError: (err: any) => {
            console.log('Failed to save account details', err)
            toast.error('Failed to save account details. Please try again')
        },
    })
}

export const useSaveWithdrawRequest = () => {
    return useMutation({
        mutationFn: (withdrawRequest: WithdrawRequest) => saveWithdrawalRequest(withdrawRequest),
        onSuccess: () => {},
        onError: (err: any) => {
            console.log('Failed to withdraw', err)
            toast.error('Failed to withdraw. Please try again')
        },
    })
}
